import axios from './axios';

export default {
  delete: (id) => axios.delete(`/it_operateurs/${id}`),
  update: (id, payload) => axios.put(`/it_operateurs/${id}`, { it_operateur: payload }),
};
